import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  company: string;
  domain: string;
  language: string;
  customerGroup: string;
}

// The tone of voice is deliberately not displayed: it is often paragraphs
// long. It still flows into the prompts untouched.
const ContextCard: React.FC<Props> = ({ company, domain, language, customerGroup }) => {
  const { t } = useTranslation();
  const items: [string, string][] = [
    [t('article.context_company'), company],
    [t('article.context_domain'), domain],
    [t('article.context_language'), language],
    [t('article.context_target_group'), customerGroup || '—'],
  ];
  return (
    <div className="p-4 border rounded-lg bg-gray-50">
      <div className="text-sm font-semibold mb-2">{t('article.context_title')}</div>
      <dl className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm">
        {items.map(([label, valueText]) => (
          <div key={label}>
            <dt className="text-gray-500">{label}</dt>
            <dd className="font-medium">{valueText}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default ContextCard;
